import React from 'react';
import { Box, Button, Chip, Typography } from '@mui/material';
import { Translate } from 'react-localize-redux';
import { PaymentRecord } from './types';
import { formatCurrency } from '../../../utils';
import { IconGenerator } from '../../../components/general/mini_components';

interface PaymentRecordsDisplayProps {
    paymentRecords: PaymentRecord[];
    currency: string;
    languageCode: string;
    translationKey?: string;
    onViewPaymentRecords: () => void;
    showViewButton?: boolean;
}

/**
 * Reusable component to display total paid amount with a button to view payment records
 */
const PaymentRecordsDisplay: React.FC<PaymentRecordsDisplayProps> = ({
    paymentRecords,
    currency,
    languageCode,
    translationKey = 'pages.hospital.billing.pdf.total_paid',
    onViewPaymentRecords,
    showViewButton = true
}) => {
    const totalPaid = React.useMemo(() => {
        return paymentRecords.reduce((sum, rec) => sum + rec.amount, 0);
    }, [paymentRecords]);

    // Only show the view button if showViewButton is true and there are actual payments
    const shouldShowButton = showViewButton && totalPaid > 0 && paymentRecords.length > 0;

    return (
        <Box display="flex" alignItems="center">
            <Typography component="span" variant="body2" fontWeight="bold" mr={1} mb={0}>
                <Translate id={translationKey} /> :
            </Typography>
            <Chip
                label={formatCurrency(totalPaid, currency, languageCode)}
                color="primary"
                style={{ fontWeight: 'bold', backgroundColor: '#4CAF50', color: '#fff', marginRight: 8 }}
                size="small"
            />
            {shouldShowButton && (
                <Button
                    variant="text"
                    onClick={onViewPaymentRecords}
                    size="small"
                    style={{ minWidth: 0, padding: 6 }}
                >
                    <IconGenerator type="view" />
                </Button>
            )}
        </Box>
    );
};

export default PaymentRecordsDisplay;
